export const getGrowthBookOverrideFlags = (userAgent: string): string | null => {
  const regex = /X-AQA-Feature-Flags-Override=([^ ]+)/;
  const match = userAgent?.match(regex);
  if (match) {
    const extractedFlags = match[1];
    
    // Convert from "feature-flag:value;" format to "feature-flag=value;" format
    if (extractedFlags.includes(':')) {
      // Preserve trailing semicolon if it exists
      const hasTrailingSemicolon = extractedFlags.endsWith(';');
      
      const result = extractedFlags
        .split(';')
        .filter(Boolean) // Remove empty entries
        .map(pair => {
          const colonIndex = pair.indexOf(':');
          if (colonIndex !== -1) {
            const key = pair.substring(0, colonIndex);
            const value = pair.substring(colonIndex + 1);
            return `${key}=${value}`;
          }
          return pair; // Keep as is if no colon
        })
        .join(';');
      
      // Add back trailing semicolon if original string had one
      return hasTrailingSemicolon ? `${result};` : result;
    }
    
    // Return as is if already in correct format or doesn't contain colons
    return extractedFlags;
  }
  return null;
};
